export class DocBar {
	public docBarLogo: string;
	public docBarHeight: string;
	public bgColor: string;
	public title: string;
	public subtitle: string;
	public isDefault: Boolean;
}
